import { defineComponent as _defineComponent } from 'vue'
import UserInfoDataService from "@/services/UserInfoDataService";
import UserNavigation from "../../AdminNavigationContainer.vue";
import ResponseData from "@/types/ResponseData";
import { ref, onMounted, onUpdated, reactive } from "vue";
import Alert from "../parts/Alert.vue";
import { useRouter } from "vue-router";
import Loading from "@/components/home/Loading";
import { useI18n } from "vue3-i18n";
import { store } from "@/store/store";
import SendEmailService from "@/services/SendEmailService";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const isLoading = ref(false);
const permissionFlg = reactive<any[]>([]);
const permissionDataFlg = reactive<any[]>([]);
const permissionDetail = reactive<any[]>([]);
const userPermissionInfo = reactive<any[]>([]);
const statusPermisList = reactive<any[]>([]);
const titleUser = ref("User Maintenance");
const i18n = useI18n();
const alertMessage = ref("null");
const alertState = ref("neutral");
const userID = store.getters.userdata;
const getData = ref(false);
permissionFlg.splice(0);
permissionDataFlg.splice(0);
const loginUserStCode = store.getters.stationCode;
const loignUserId = store.getters.cognitoUserName;

onMounted(function () {
  isLoading.value = true;
  //【PermissionDetail】テーブルから詳細内容取得
  getPermissionDetailInfo();
});

const backUserInfo = () => {
  store.dispatch("setShowPage", "UserInquiryByDestination");
};

/** 権限明細情報取得 */
const getPermissionDetailInfo = () => {
  isLoading.value = true;
  permissionDetail.splice(0);
  // get Permission Detail Information
  UserInfoDataService.getPermissionDetailList({"userID": userID})
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        const permissionDetailList = response.data;
        if (permissionDetailList.length !== 0) {
          for (let info of permissionDetailList) {
            if(loginUserStCode == 1000 ||  loignUserId == userID)
            {
              var obj2 = {
                mainMenuCode: info.mainMenuCode,
                mainTitleName: info.mainTitleCode.mainTitleName,
                mainTitleCode: info.mainTitleCode.mainTitleCode,
                mainMenuName: info.mainMenuName,
              };
              permissionDetail.push(obj2);
            }
            else{
              if(info.mainTitleCode.mainTitleCode != "MT0008"){
                var obj3 = {
                  mainMenuCode: info.mainMenuCode,
                  mainTitleName: info.mainTitleCode.mainTitleName,
                  mainTitleCode: info.mainTitleCode.mainTitleCode,
                  mainMenuName: info.mainMenuName,
                };
                permissionDetail.push(obj3);
              }
            }
          }
        }
        getUserPermissionDetailInfo();
      }
      getData.value = true;
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err014");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** ユーザーが持つ権限明細情報取得 */
const getUserPermissionDetailInfo = () => {
  isLoading.value = true;
  userPermissionInfo.splice(0);
  const data = {
    userId: userID,
  };

  // get User Permission Information
  UserInfoDataService.getUserPermission(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        for (let info of response.data) {
          if(loginUserStCode == 1000 ||  loignUserId == userID)
            {
              var obj2 = {
                userId: info.userId,
                mainMenuCode: info.mainMenuCode.mainMenuCode,
                mainTitleCode: info.mainMenuCode.mainTitleCode.mainTitleCode,
                status: info.status,
              };
              userPermissionInfo.push(obj2);
            }
            else{
              if(info.mainMenuCode.mainTitleCode.mainTitleCode != "MT0008"){
                var obj3 = {
                  userId: info.userId,
                  mainMenuCode: info.mainMenuCode.mainMenuCode,
                  mainTitleCode: info.mainMenuCode.mainTitleCode.mainTitleCode,
                  status: info.status,
                };
                userPermissionInfo.push(obj3);
              }
            }
        }
        statusPermisList.splice(0);
        for(let idxMenu of permissionDetail){
          var chkResult = userPermissionInfo.filter((permission: { mainMenuCode: any; }) => permission.mainMenuCode == idxMenu.mainMenuCode);
          if(chkResult.length == 0 || chkResult[0].status == "3"){
            statusPermisList.push("");
          }else if(chkResult[0].status == "1"){
            statusPermisList.push("waiting for node manager approval");
          }else if(chkResult[0].status == "2"){
            statusPermisList.push("waiting for SMC manager approval");
          }
        }
        checkCheckBox();
      }
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err013");
      alertState.value = "error";
      isLoading.value = false;
    });
};

const checkCheckBox = () => {
  permissionDataFlg.splice(0);

  // 対象ユーザーの為権限があるサブメニューにチェック付ける
  for (var info = 0; info < userPermissionInfo.length; info++) {
    var chkItem = document.getElementById("chk" + userPermissionInfo[info].mainMenuCode) as HTMLInputElement;
    if (chkItem instanceof HTMLInputElement) {
      if (userPermissionInfo[info].status == "3") {
        chkItem.checked = true;
        permissionDataFlg.push(userPermissionInfo[info].mainMenuCode);
      } else {
        chkItem.disabled = true;
        chkItem.checked = false;
      }

      var chkHeaderID = "chkHeader" + userPermissionInfo[info].mainTitleCode;
      var isHeaderCheck = true;
      var chkName = "chk" + userPermissionInfo[info].mainTitleCode;
      var allChk = document.getElementsByName(chkName);
      // サブチェックボックスが【1】行以上ならヘッダチェックに反映する
      for (var i = 0; i < allChk.length; i++) {
        var chkHeaderItem = allChk[i] as HTMLInputElement;
        if (chkHeaderItem.checked == false) {
          isHeaderCheck = false;
        }
      }
      (document.getElementById(chkHeaderID) as HTMLInputElement).checked = isHeaderCheck;
    }
  }
};

/** チェックボックス押下時の処理関数 */
const chkChange = (param, index) => {
  var chkHeaderID = "chkHeader" + param;
  var isHeaderCheck = true;
  var chkName = "chk" + param;
  var allChk = document.getElementsByName(chkName);
  // サブチェックボックスが【1】行以上ならヘッダチェックに反映する
  for (var i = 0; i < allChk.length; i++) {
    if (allChk[i].checked == false) {
      isHeaderCheck = false;
    }
  }
  document.getElementById(chkHeaderID).checked = isHeaderCheck;
};

/** ヘッダチェックボックス変更 */
const chkHeaderChange = (param, index) => {
  var chkHeaderID = "chkHeader" + param;
  var chkName = "chk" + param;
  var isHeaderCheck = document.getElementById(chkHeaderID).checked;
  var allChk = document.getElementsByName(chkName);
  // 各チェック未チェックの反映
  for (var i = 0; i < allChk.length; i++) {
    if (allChk[i].disabled) {
      index++;
    } else {
      allChk[i].checked = isHeaderCheck;
      index++;
    }
  }
};

const updateUserPermission = () => {
  isLoading.value = true;
  permissionFlg.splice(0);
  alertMessage.value = "null";
  alertState.value = "neutral";
  const usrID = userID;
  //ユーザーが選択した権限リスト
  for (var j = 0; j < permissionDetail.length; j++) {
    if (permissionDetail[j].mainMenuCode) {
      const chkFlg = document.getElementById(
        "chk" + permissionDetail[j].mainMenuCode
      );
      if (chkFlg.checked == true) {
        permissionFlg.push(permissionDetail[j].mainMenuCode);
      }
    }
  }

  var requestData = {
    usrID: usrID, 
    chkFlg: permissionFlg,
    oldFlg: permissionDataFlg, 
    loginUserId: store.getters.cognitoUserName
  }
  UserInfoDataService.updatedUserPermissionData(requestData)
    .then((response: ResponseData) => {
      // 2023/05/18 MDCR 修正 start
      if (response.data == "NoChanged") {
        alertMessage.value = i18n.t("suc031");
        alertState.value = "success";
        isLoading.value = false;
      } else if (response.data == "") {
          getPermissionDetailInfo();
          alertMessage.value = i18n.t("suc030");
          alertState.value = "success";
          isLoading.value = false;
      } else if (response.data == "1") {
        // 拠点管理者へメール送信
        const data ={
          userId: usrID, 
          stationCode: store.getters.selectedStation,
          targetMailFormat: "mail_node_manager_notice", 
          sendingPattern: "kyoten_notice", 
          loginUserId: store.getters.cognitoUserName
        };
        SendEmailService.sendEmail(data)
        .then((response2: ResponseData) => {
          getPermissionDetailInfo();
          alertMessage.value = i18n.t("suc030");
          alertState.value = "success";
          isLoading.value = false;
        })
        .catch((e: Error) => {
          alertMessage.value = "Fail to send notice email of user approval";
          alertState.value = "error";
          isLoading.value = false;
        });
      } else {
        // SMC管理者へメール送信
        const data ={
          userId: usrID, 
          menuList : response.data
        };
        SendEmailService.sendEmailByMenu(data)
          .then((response2: ResponseData) => {
            if (response2.data.length != 0) {
              for (var i = 0; i < response2.data.length; i ++) {
                const smcData ={
                  userId: usrID, 
                  targetMailFormat: "mail_SMC_manager_notice", 
                  sendingPattern: "SMC_manager_notice", 
                  email: response2.data[i]['email'],
                  menuList: response2.data[i]['menuList'],
                  loginUserId: store.getters.cognitoUserName
                };

                SendEmailService.sendEmail(smcData)
                .catch((e: Error) => {
                  alertMessage.value = "Fail to send notice email of permission approval";
                  alertState.value = "error";
                  isLoading.value = false;
                });
              }
            }
            getPermissionDetailInfo();
            alertMessage.value = i18n.t("suc030");
            alertState.value = "success";
            isLoading.value = false;
        })
        .catch((e: Error) => {
          alertMessage.value = "Fail to send notice email of permission approval";
          alertState.value = "error";
          isLoading.value = false;
        });
      }     
      // 2023/05/18 MDCR 修正 end
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err024");
      alertState.value = "error";
      isLoading.value = false;
    });
};

onUpdated(function () {
  try {
    var tableHeight = 0;
    var dataHeight = document.getElementById("usertbltbody")?.clientHeight;
    if (dataHeight != 0) {
      tableHeight = document.getElementById("usermydiv")?.clientHeight;
      if (dataHeight < tableHeight) {
        document.getElementById("usertblbodydiv").style.width = "100%";
      } else {
        document.getElementById("usertblbodydiv").style.width =
          "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
  isLoading.value = false;
});

const disabledCheck = (item) => {
  if(userPermissionInfo.some(userPermit => userPermit.mainMenuCode == item.mainMenuCode && userPermit.status == "3")) {
    return false;
  }else if (!(userPermissionInfo.some(userPermit => userPermit.mainMenuCode == item.mainMenuCode)) && loginUserStCode == '1000' || (item.mainTitleCode != 'MT0008' && loginUserStCode != '1000'))
  {
    return false;
  }
  return true;
}


const __returned__ = { router, isLoading, permissionFlg, permissionDataFlg, permissionDetail, userPermissionInfo, statusPermisList, titleUser, i18n, alertMessage, alertState, userID, getData, loginUserStCode, loignUserId, backUserInfo, getPermissionDetailInfo, getUserPermissionDetailInfo, checkCheckBox, chkChange, chkHeaderChange, updateUserPermission, disabledCheck, UserNavigation, Alert, Loading }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})